import GridOn from "@material-ui/icons/GridOn";
import Image from "@material-ui/icons/Image";
import Apps from "@material-ui/icons/Apps";
import BlurLinearIcon from "@material-ui/icons/BlurLinear";
import { request_ } from "./AppRoutes";
import {
  requestHumanResources,
  view_personal_file,
  manage_personal_file,
  edit_personal_file,
  delete_personal_file,
  remunerations,
  endowments,
} from "./HumanResources/HumanResourcesRoutes";
import {
  clinicRequests,
  clinicEndowments,
  clinicOrders,
  endowmentsTens,
  clinicEndowmentsDetail,
  covenants,
  benefits,
  covenantsdetail,
  documents,
  packages,
  patientFile,
  reportPatient,
  patientFileDetails,
  clinicRequest,
  assignments,
  billing_tasks,
  billing,
} from "./BillingAndCollection/BillingAndCollectionRoutes";
import {
  warehouseStorage,
  warehousePharmacy,
  outcomeStorage,
  outcomePharmacy,
  incomeStorage,
  incomePharmacy,
  purchases,
  transport_all,
  transport_tasks,
  transport_driver,
  boss,
} from "./Operations/OperationsRoutes";
import { rotary } from "./PeopleManagment/PeopleManagementRoutes";

// Secciones del menú, en el orden en que se muestran.
export const SECTIONS = {
  management: {
    collapse: true,
    name: "Gerencia",
    icon: BlurLinearIcon,
    state: "GerenciaCollapse",
    views: [],
  },
  human_resources: {
    collapse: true,
    name: "Recursos Humanos",
    rtlName: "الجداول",
    icon: GridOn,
    state: "RRHHCollapse",
    views: [],
  },
  billing: {
    collapse: true,
    name: "Facturación y Cobranzas",
    rtlName: "إستمارات",
    icon: "content_paste",
    state: "facturacionCollapse",
    views: [],
  },
  clinic: {
    collapse: true,
    name: "Clinica",
    rtlName: "صفحات",
    icon: Image,
    state: "clinicaCollapse",
    views: [],
  },
  operations: {
    collapse: true,
    name: "Operaciones",
    rtlName: "المكونات",
    icon: Apps,
    state: "operacionesCollapse",
    views: [],
  },
};

// Subgrupo del menú de Operaciones que agrupa las tareas de transporte.
export const GROUPS = {
  transport: { ...transport_all, views: [] },
};

// Una entrada por módulo. `key` es la clave que guarda el back. `route` es el
// objeto de ruta existente (null si el módulo solo hace aparecer la sección).
// `group` indica un subgrupo dentro de la sección. El orden de esta lista es
// el orden en que se muestran los módulos dentro de su sección.
export const MODULES = [
  { key: "management.menu", section: "management", route: null },

  { key: "human_resources.requests", section: "human_resources", route: requestHumanResources },
  { key: "human_resources.personal_file_view", section: "human_resources", route: view_personal_file },
  { key: "human_resources.personal_file_manage", section: "human_resources", route: manage_personal_file },
  { key: "human_resources.personal_file_edit", section: "human_resources", route: edit_personal_file },
  { key: "human_resources.personal_file_delete", section: "human_resources", route: delete_personal_file },
  { key: "human_resources.remunerations", section: "human_resources", route: remunerations },
  { key: "human_resources.tasks", section: "human_resources", route: request_ },
  { key: "human_resources.endowments", section: "human_resources", route: endowments },
  { key: "human_resources.endowments_detail", section: "human_resources", route: clinicEndowmentsDetail },

  { key: "billing.tasks", section: "billing", route: billing_tasks },
  { key: "billing.patient_file", section: "billing", route: patientFile },
  { key: "billing.patient_file_detail", section: "billing", route: patientFileDetails },
  { key: "billing.billing", section: "billing", route: billing },

  { key: "clinic.requests", section: "clinic", route: clinicRequests },
  { key: "clinic.endowments", section: "clinic", route: clinicEndowments },
  { key: "clinic.endowments_detail", section: "clinic", route: clinicEndowmentsDetail },
  { key: "clinic.tasks", section: "clinic", route: clinicRequest },
  { key: "clinic.covenants", section: "clinic", route: covenants },
  { key: "clinic.benefits", section: "clinic", route: benefits },
  { key: "clinic.patient_file", section: "clinic", route: patientFile },
  { key: "clinic.patient_file_detail", section: "clinic", route: patientFileDetails },
  { key: "clinic.covenants_detail", section: "clinic", route: covenantsdetail },
  { key: "clinic.documents", section: "clinic", route: documents },
  { key: "clinic.packages", section: "clinic", route: packages },
  { key: "clinic.assignments", section: "clinic", route: assignments },
  { key: "clinic.rotary", section: "clinic", route: rotary },
  { key: "clinic.orders", section: "clinic", route: clinicOrders },
  { key: "clinic.endowments_tens", section: "clinic", route: endowmentsTens },
  { key: "clinic.patient_report", section: "clinic", route: reportPatient },

  { key: "operations.warehouse_storage", section: "operations", route: warehouseStorage },
  { key: "operations.warehouse_pharmacy", section: "operations", route: warehousePharmacy },
  { key: "operations.outcome_storage", section: "operations", route: outcomeStorage },
  { key: "operations.outcome_pharmacy", section: "operations", route: outcomePharmacy },
  { key: "operations.income_storage", section: "operations", route: incomeStorage },
  { key: "operations.income_pharmacy", section: "operations", route: incomePharmacy },
  { key: "operations.purchases", section: "operations", route: purchases },
  { key: "operations.transport_tasks", section: "operations", group: "transport", route: transport_tasks },
  { key: "operations.transport_driver", section: "operations", group: "transport", route: transport_driver },
  { key: "operations.boss", section: "operations", route: boss },
];

export const MODULE_BY_KEY = MODULES.reduce((acc, module) => {
  acc[module.key] = module;
  return acc;
}, {});
